import { autoinject } from "aurelia-framework";

import { HospiceClient } from "../common/hospice-client";
import { ICheckEligibilityQuery, ICheckEligibilityResult, IEligibilityIssueCount } from "../interfaces/i-eligibility";

@autoinject()
export class EligibilityService {
    private _httpClient: HospiceClient;
    private _baseUrl: string = "/api/v1/eligibility";

    public constructor(httpClient: HospiceClient) {
        this._httpClient = httpClient;
    }

    public async check(query: ICheckEligibilityQuery) {
        return await this._httpClient
            .build(`${this._baseUrl}/check`)
            .useQueryString(query)
            .fetch<ICheckEligibilityResult>();
    }

    public async getEligibilityIssues(locationIds: string[]) {
        return await this._httpClient
            .build(`${this._baseUrl}/issues`)
            .useQueryString({ locationIds })
            .fetch<IEligibilityIssueCount>();
    }
}
